/* eslint-disable max-len */
export default {
    threats: {
        excerpt: {
            title: 'Are you not sure if your digital assets and applications require cybersecurity support?',
            list: [
                'Why is the risk of an attack on data so great?',
                'What exactly will you lose in case of a successful attack?',
                'Why can data theft cost you as much as 4% of your annual turnover?',
                'What actions and tools will ensure your complete security?'
            ],
            button: 'See more'
        },
        content: {
            title: 'Are the data you collect secure?',
            description: 'The number of attacks on the organization\'s infrastructure and data theft has been growing at a breathtaking speed in the recent years.',
            button: 'See a video'
        }
    },
    offer: {
        excerpt: {
            title: 'Why should you consider Lemlock as your cybersecurity partner?',
            list: [
                'Why does comprehensive security require an interdisciplinary approach?',
                'What are the solutions offered by lemlock?',
                'How to protect the report against data leakage?',
                'How can you prove that your data are well protected?'
            ],
            button: 'Check offer',
            button_pricing: 'Pricing'
        },
        content: {
            title: 'Secure your applications and digital assets.',
            description: 'Protection of the organization\'s resources is a challenge that requires knowledge and actions requiring both legal and technological expertise.',
            button: 'Check offer'
        }
    },
    popup: {
        text: 'Do you suspect that your organization has been hacked? Contact us immediately!',
        link: 'https://www.lemlock.com/post-breach-steps/'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/en/home.js